
<template>
  <div>
    <!-- <div class="mainTitle">代理等级</div> -->
    <el-card >
      <el-row :span="24">
        <el-col :span="12">
          <el-button
            type="primary"
            @click="addFormVisible = true"
            :disabled="page.total>=6"
            icon="el-icon-plus"
          >添加</el-button>
          <span style="color:#888;margin-left:10px">最多设置六个代理</span>
          <!-- <el-button type="danger" @click="batchDeleteAgentLevel" icon="el-icon-minus">批量删除</el-button> -->
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="selectionChange"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
      >
        <!-- <el-table-column prop="grade" label="等级(1,2,3,...)"></el-table-column> -->
        <el-table-column align="center" prop="sort" label="序号" min-width="5%"></el-table-column>
        <el-table-column prop="name" min-width="20%" label="代理等级" align="center">
          <template slot-scope="row">
            <!-- <div class="rowName" :style="`background:`+row.row.color">{{row.row.name}}</div> -->
            <span
              v-if="row.row.name.indexOf('合伙人')!==-1"
              class="purple"
            >{{row.row.name}}</span>
            <span
              v-else-if="row.row.name.indexOf('金牌')!==-1"
              class="gold"
            >{{row.row.name}}</span>
            <span
              v-else-if="row.row.name.indexOf('银牌')!==-1"
              class="gray"
            >{{row.row.name}}</span>
            <span
              
              class="coppery"v-else-if="row.row.name.indexOf('铜牌')!==-1"
            >{{row.row.name}}</span>
            <span v-else class="general">{{row.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="15%" prop="discount" label="代理折扣" align="center">
          <template slot-scope="row">
            <div>{{row.row.discount*10||0}}折</div>
          </template>
        </el-table-column>
        <el-table-column prop="grade" label="等级门槛" min-width="30%" align="center">
          <template slot-scope="row">
            <div
              v-if="(row.row.dealAmountMin||row.row.dealAmountMax)||(row.row.dealCountMin||row.row.dealCountMax)"
            >
              <span
                v-if="row.row.dealAmountMin||row.row.dealAmountMax"
              >{{row.row.dealAmountMin?+row.row.dealAmountMin+'≤':''}}成交金额 {{row.row.dealAmountMax?'<'+row.row.dealAmountMax:''}}</span>
              <span>
                <span
                  v-if="(row.row.dealAmountMin||row.row.dealAmountMax)&&(row.row.dealCountMin||row.row.dealCountMax)"
                  style="margin:0px 0px"
                >;</span>
              </span>
              <span
                :style="(row.row.dealAmountMin||row.row.dealAmountMax)?'margin-left:0px':''"
                v-if="row.row.dealCountMin||row.row.dealCountMax"
              >{{row.row.dealCountMin?+row.row.dealCountMin+'单≤':''}}成交单量{{row.row.dealCountMax?'<'+row.row.dealCountMax:''}}单</span>
            </div>
            <div v-else >
              <span>无</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="15%" prop="agentUserInfoCount" label="代理人数" align="center"></el-table-column>
        <!-- <el-table-column align="center" width="150px" prop="enabled" label="状态">
          <template slot-scope="row">
            <el-switch
              v-model="row.row.enabled"
              active-value="1"
              inactive-value="0"
              @change="updateSwitching(row)"
              class="switchStyle"
              active-text="开"
              inactive-text="关"
            ></el-switch>
          </template>
        </el-table-column> -->
        <el-table-column prop label="操作" min-width="15%" align="center">
          <template slot-scope="scope">
            <div class="operationGroup" style="display: flex;justify-content: flex-start;">
              <!-- <span @click="selection = scope.row.id, editFormVisible = true">编辑</span> -->
              <i
                class="el-icon-edit icon-style"
                title="编辑"
                style="width:50%"
                @click="selection = scope.row.id, editFormVisible = true"
              ></i>

              <i
                class="el-icon-delete icon-style"
                v-if="scope.row.name!='金牌代理商'&&scope.row.name!='银牌代理商'&&scope.row.name!='铜牌代理商'&&scope.row.agentUserInfoCount==0"
                style="width:50%"
                @click="deleteAgentLevel(scope.row)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>-->
    </el-card>

    <el-dialog title="添加等级" :visible.sync="addFormVisible" width="400px" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="等级名称" prop="name">
            <el-input
            style="width:71.5%"
              v-model="addForm.name"
              placeholder="请输入等级名称"
              auto-complete="off"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="代理折扣" prop="discount">
            <div style="width: 100%;">
              <el-input
                v-if="offTimeRadioAuto==1"
                v-model="addForm.discount"
                placeholder="请输入代理折扣"
                auto-complete="off"
                maxlength="50"
                type="number"
                style="width: 200px"
              >
                <template slot="append">折</template>
              </el-input>
              <el-select
                v-else
                style="width: 200px"
                v-model="addForm.discount"
                placeholder="请输入代理折扣"
              >
                <el-option
                  v-for="(item,index) in discountOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                  <template slot="append">折</template>
                </el-option>
              </el-select>
              <!-- <el-checkbox v-model="offTimeRadio" label="1" @change="offTimeNull()">不打折</el-checkbox> -->
              <el-checkbox v-model="offTimeRadioAuto" label="1">自定义</el-checkbox>
            </div>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24" style="margin-top:-10px">
          <el-form-item label="等级备注">
            <!-- <el-input
              type="number"
              v-model="addForm.grade"
              placeholder="等级(1,2,3,...)"
              auto-complete="off"
              maxlength="10"
            ></el-input>-->
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24" style="margin-top:-20px;">
          <div class="ssssss">
            <div style="width:35%">
              <el-input
                type="number"
                size="small"
                style="width:100%"
                v-model="addForm.dealAmountMin"
                placeholder="上限"
                auto-complete="off"
                @change="dealAmountChangeAdd"
                :min="0"
                maxlength="10"
              ></el-input>
            </div>
            <div style="width:22%;line-height: 30px;">≤ 成交金额&lt;</div>
            <div style="width:35%">
              <el-input
                size="small"
                style="width:100%"
                type="number"
                v-model="addForm.dealAmountMax"
                :min="0"
                placeholder="上限"
                @change="dealAmountChangeAdd"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </div>
          </div>
          <div
            v-if="dealAmountChangeAddVal"
            style="margin:-6px 0 10px 20px;color: #F56C6C;font-size: 12px;"
          >成交金额输入有误</div>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24" style="margin-bottom:10px">
          <div class="ssssss">
            <div style="width:35%">
              <el-input
                type="number"
                size="small"
                style="width:100%"
                v-model="addForm.dealCountMin"
                placeholder="上限"
                @change="dealCountChangeAdd"
                :min="0"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </div>
            <div style="width:22%;line-height: 30px;">≤ 成交单量&lt; </div>
            <div style="width:35%">
              <el-input
                size="small"
                style="width:100%"
                @change="dealCountChangeAdd"
                :min="0"
                type="number"
                v-model="addForm.dealCountMax"
                placeholder="上限"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </div>
          </div>
          <div
            v-if="dealCountChangeAddVal"
            style="margin:-6px 0 10px 20px;color: #F56C6C;font-size: 12px;"
          >成交单量输入有误</div>
        </el-col>
        <!-- <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="等级颜色" prop="color">
            <el-radio-group class="dengjiyanse" v-model="addForm.color">
              <el-radio :label="item" v-for="(item,index) in colorList" :key="index">
                <template>
                  <div
                    class="append-color"
                    :class="addForm.color==item?'select-color':''"
                    :style="'background-color:'+item"
                  ></div>
                </template>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="等级状态" prop="enabled">
            <el-radio v-model="addForm.enabled" label="1">启用</el-radio>
            <el-radio v-model="addForm.enabled" label="0">禁用</el-radio>
          </el-form-item>
        </el-col> -->
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right;">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAgentLevel">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑等级" :visible.sync="editFormVisible" width="400px" left>
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="等级名称" prop="name">
            <el-input
            style="width:71.5%"
              v-model="editForm.name"
              placeholder="请输入等级名称"
              auto-complete="off"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="代理折扣" prop="discount">
            <div style="width: 100%;">
              <el-input
                v-if="offTimeRadioAuto==1"
                v-model="editForm.discount"
                placeholder="请输入代理折扣"
                auto-complete="off"
                maxlength="50"
                type="number"
                style="width: 200px"
              >
                <template slot="append">折</template>
              </el-input>
              <el-select
                v-else
                style="width: 200px"
                v-model="editForm.discount"
                placeholder="请输入代理折扣"
              >
                <el-option
                  v-for="(item,index) in discountOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                  <template slot="append">折</template>
                </el-option>
              </el-select>
              <el-checkbox v-model="offTimeRadioAuto" label="1">自定义</el-checkbox>
              <!-- <el-checkbox v-model="offTimeRadio" label="1" @change="offTimeNull()">不打折</el-checkbox> -->
            </div>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24" style="margin-top:-10px">
          <el-form-item label="等级备注">
            <!-- <el-input
              type="number"
              v-model="addForm.grade"
              placeholder="等级(1,2,3,...)"
              auto-complete="off"
              maxlength="10"
            ></el-input>-->
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24" style="margin-top:-20px;">
          <div class="ssssss">
            <div style="width:35%">
              <el-input
                type="number"
                size="small"
                style="width:100%"
                @change="dealAmountChangeEdit"
                v-model="editForm.dealAmountMin"
                placeholder="上限"
                auto-complete="off"
                :min="0"
                maxlength="10"
              ></el-input>
            </div>
            <div style="width:22%;line-height: 30px;">≤ 成交金额&lt;</div>
            <div style="width:35%">
              <el-input
                size="small"
                style="width:100%"
                @change="dealAmountChangeEdit"
                type="number"
                v-model="editForm.dealAmountMax"
                :min="0"
                placeholder="上限"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </div>
          </div>
          <div
            v-if="dealAmountChangeEditVal"
            style="margin:-6px 0 10px 20px;color: #F56C6C;font-size: 12px;"
          >成交金额输入有误</div>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24" style="margin-bottom:10px">
          <div class="ssssss">
            <div style="width:35%">
              <el-input
                type="number"
                size="small"
                style="width:100%"
                @change="dealCountChangeEdit"
                v-model="editForm.dealCountMin"
                placeholder="上限"
                :min="0"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </div>
            <div style="width:22%;line-height: 30px;">≤ 成交单量&lt;</div>
            <div style="width:35%">
              <el-input
                size="small"
                style="width:100%"
                :min="0"
                type="number"
                v-model="editForm.dealCountMax"
                placeholder="上限"
                @change="dealCountChangeEdit"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </div>
          </div>
          <div
            v-if="dealCountChangeEditVal"
            style="margin:-6px 0 10px 20px;color: #F56C6C;font-size: 12px;"
          >成交单量输入有误</div>
        </el-col>
        <!-- <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="等级颜色" prop="color">
            <el-radio-group class="dengjiyanse" v-model="editForm.color">
              <el-radio :label="item" v-for="(item,index) in colorList" :key="index">
                <template>
                  <div
                    class="append-color"
                    :class="editForm.color==item?'select-color':''"
                    :style="'background-color:'+item"
                  ></div>
                </template>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="等级状态" prop="enabled">
            <el-radio v-model="editForm.enabled" label="1">启用</el-radio>
            <el-radio v-model="editForm.enabled" label="0">禁用</el-radio>
          </el-form-item>
        </el-col> -->
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right;margin-top:10px">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateAgentLevel">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      colorList: [
        "rgba(255, 177, 2, 1)",
        "rgba(162, 170, 188, 1)",
        "rgba(186, 160, 126, 1)",
        "rgba(199, 113, 246, 1)",
        "rgba(255, 195, 73, 1)",
        "rgba(255, 85, 85, 1)",
        "rgba(36, 210, 181, 1)"
      ],
      discountOptions: [
        {
          value: 1,
          label: "不打折"
        },
        {
          value: 0.9,
          label: "9折"
        },
        {
          value: 0.8,
          label: "8折"
        },

        {
          value: 0.7,
          label: "7折"
        },
        {
          value: 0.6,
          label: "6折"
        },
        {
          value: 0.5,
          label: "5折"
        },
        {
          value: 0.4,
          label: "4折"
        },
        {
          value: 0.3,
          label: "3折"
        },
        {
          value: 0.2,
          label: "2折"
        },
        {
          value: 0.1,
          label: "1折"
        }
      ],
      addFormVisible: false,
      editFormVisible: false,
      searchForm: {},
      addForm: {
        grade: "",
        name: "",
        dealAmountMax: null,
        dealAmountMin: null,
        dealCountMax: null,
        dealCountMin: null,
        discount: null,
        // color: "",
        // enabled: "1",
      },
      offTimeRadio: null,
      offTimeRadioAuto: null,
      chackAuto: null,
      addFormRules: {
        grade: [
          {
            required: true,
            message: "请输入等级(1,2,3,...)",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "等级(1,2,3,...)格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入等级名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 6,
            message: "级别名称长度在1到6个字"
          }
        ],
        enabled: {
          required: true,
          message: "请选择等级状态",
          trigger: "change"
        },
        color: {
          required: true,
          message: "请选择等级颜色",
          trigger: "change"
        },
        discount: [
          {
            required: true,
            message: "请选择折扣",
            trigger: "change"
          },
          {
            pattern: /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/,
            message: "折扣0-1"
          }
        ]
      },
      editForm: {
        name: "",
        grade: "",
        enabled: "1"
      },
      editFormRules: {
        color: {
          required: true,
          message: "请选择等级颜色",
          trigger: "change"
        },
        name: [
          {
            required: true,
            message: "请输入等级名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 6,
            message: "等级名称长度在1到6个字"
          }
        ],
        grade: [
          {
            required: true,
            message: "请输入等级(1,2,3,...)",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "等级(1,2,3,...)格式不正确"
          }
        ],
        enabled: {
          required: true,
          message: "请选择等级状态",
          trigger: "change"
        },
        discount: [
          {
            required: true,
            message: "请选择折扣",
            trigger: "change"
          },
          {
            pattern: /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/,
            message: "折扣0-1"
          }
        ]
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/agentLevel/upload`,
      fileList: [],
      dealAmountChangeAddVal: false,
      dealCountChangeAddVal: false,
      dealCountChangeEditVal: false,
      dealAmountChangeEditVal: false,
      loading: true
    };
  },
  methods: {
    dealAmountChangeEdit(val) {
      if (this.editForm.dealAmountMax && this.editForm.dealAmountMin)
        if (
          Number(this.editForm.dealAmountMax) <=
          Number(this.editForm.dealAmountMin)
        ) {
          this.dealAmountChangeEditVal = true;
        } else {
          this.dealAmountChangeEditVal = false;
        }
    },
    dealAmountChangeAdd(val) {
      if (this.addForm.dealAmountMax && this.addForm.dealAmountMin)
        if (
          Number(this.addForm.dealAmountMax) <=
          Number(this.addForm.dealAmountMin)
        ) {
          this.dealAmountChangeAddVal = true;
        } else {
          this.dealAmountChangeAddVal = false;
        }
    },
    dealCountChangeEdit(val) {
      if (this.editForm.dealCountMax && this.editForm.dealCountMin)
        if (
          Number(this.editForm.dealCountMax) <=
          Number(this.editForm.dealCountMin)
        ) {
          this.dealCountChangeEditVal = true;
        } else {
          this.dealCountChangeEditVal = false;
        }
    },
    dealCountChangeAdd(val) {
      if (this.addForm.dealCountMax && this.addForm.dealCountMin)
        if (
          Number(this.addForm.dealCountMax) <= Number(this.addForm.dealCountMin)
        ) {
          this.dealCountChangeAddVal = true;
        } else {
          this.dealCountChangeAddVal = false;
        }
    },
    offTimeNull() {
      if (this.offTimeRadio == 1) {
        this.offTimeDisabled = true;
        this.addForm.discount = 1;
      } else {
        this.addForm.discount = null;
        this.offTimeDisabled = false;
      }
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getAgentLevel() {
      this.api.agentLevel
        .getAgentLevel({
          id: this.selection
        })
        .then(result => {
          this.editForm = result.data;
          this.editForm.enabled = String(this.editForm.enabled);
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateSwitching(row) {
      let obj = {
        id: row.row.id,
        enabled: row.row.enabled
      };
      this.api.agentLevel.updateAgentLevel(obj).then(result => {
        if (result.success) {
          this.pageList();
          this.$message.success(result.message);
        } else {
          this.pageList();
          this.$message.error(result.message);
        }
      });
    },
    pageList() {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.agentLevel
        .pageList(this.searchForm)
        .then(result => {
          result.data.records.forEach((element, index) => {
            element.sort = index + 1;
            element.colors = element.color;
          });
          console.log(result.data.records[0].colors == "rgba(255, 177, 2, 1)");

          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          for (let i in this.page.rows) {
            this.page.rows[i].enabled = String(this.page.rows[i].enabled);
            this.page.rows[i].index = 1;
          }

          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addAgentLevel() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (this.addForm.dealAmountMax && this.addForm.dealAmountMin)
            if (
              Number(this.addForm.dealAmountMax) <=
              Number(this.addForm.dealAmountMin)
            ) {
              return this.$message.error("成交金额输入有误");
            }
          if (this.addForm.dealCountMax && this.addForm.dealCountMin)
            if (
              Number(this.addForm.dealCountMax) <=
              Number(this.addForm.dealCountMin)
            ) {
              return this.$message.error("成交单量输入有误");
            }
          this.addForm.dealAmountMax =
            Number(this.addForm.dealAmountMax) || null;
          this.addForm.dealAmountMin =
            Number(this.addForm.dealAmountMin) || null;
          // this.addForm.dealCountMin = Number(this.addForm.dealCountMin) || null;
          // this.addForm.dealCountMax = Number(this.addForm.dealCountMax) || null;
          this.api.agentLevel
            .addAgentLevel(this.addForm)
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.pageList();
                this.addFormVisible = false;
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateAgentLevel() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          if (this.editForm.dealCountMax && this.editForm.dealCountMin)
            if (
              Number(this.editForm.dealCountMax) <=
              Number(this.editForm.dealCountMin)
            ) {
              return this.$message.error("成交单量输入有误");
            }
          if (this.editForm.dealAmountMax && this.editForm.dealAmountMin)
            if (
              Number(this.editForm.dealAmountMax) <=
              Number(this.editForm.dealAmountMin)
            ) {
              return this.$message.error("成交金额输入有误");
            }
          this.editForm.dealAmountMax =
            Number(this.editForm.dealAmountMax) || null;
          this.editForm.dealAmountMin =
            Number(this.editForm.dealAmountMin) || null;
          // this.editForm.dealCountMin = Number(this.editForm.dealCountMin)||null;
          // this.editForm.dealCountMax = Number(this.editForm.dealCountMax)||null;
          this.api.agentLevel
            .updateAgentLevel(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteAgentLevel(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.agentLevel
            .deleteAgentLevel([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteAgentLevel() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.agentLevel
            .deleteAgentLevel(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      if (!response.success) {
        return this.$message.error(response.message);
      }
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.agentLevel
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.api.agentLevel
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.addForm = {
          grade: "",
          name: "",
          enabled: "1",
          dealAmountMax: null,
          dealAmountMin: null,
          dealCountMax: null,
          dealCountMin: null,
          discount: null,
          color: ""
        };
        this.dealAmountChangeAddVal = false;
        this.dealCountChangeAddVal = false;
        this.dealCountChangeEditVal = false;
        this.dealAmountChangeEditVal = false;
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      this.dealAmountChangeAddVal = false;
      this.dealCountChangeAddVal = false;
      this.dealCountChangeEditVal = false;
      this.dealAmountChangeEditVal = false;
      if (!newVal) {
        this.$refs.editForm.resetFields();
        // this.pageList();
      } else {
        this.getAgentLevel();
      }
    }
  },
  mounted() {
    this.pageList();
  }
};
</script>
<style lang="less" scope>
.rowName {
  width: 80px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background-color: rgba(255, 177, 2, 1);
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #fff;
  overflow: hidden;
}
.dengjiyanse {
  .el-radio__input {
    display: none !important;
  }
  .el-radio__label {
    padding-left: 0px !important;
  }
  .el-radio {
    margin-right: 6px !important;
  }
  .append-color {
    width: 20px;
    height: 20px;
    box-sizing: border-box;
  }
  .append-color:hover {
    border: 2px solid rgba(77, 148, 255, 1);
  }
  .select-color {
    border: 2px solid rgba(77, 148, 255, 1);
  }
}
.ssssss {
  display: flex;
  align-content: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-left: 13px;
}
</style>


// WEBPACK FOOTER //
// src/components/agentLevel/index.vue